module.exports = __webpack_public_path__ + "img/phone-haulage-1.7e14a7bf.png";